module.exports = __webpack_public_path__ + "img/subscription-background.330a59a8.svg";